import { AgeGroup, AvailableCriteria, FilterElementType, GroupAgeGroup } from '@schooly/api';
import { PropertiesTextIds } from '@schooly/constants';

export function resolveAgeGroupsFromIds(
  ageGroupIds: string[],
  ageGroups: AgeGroup[],
): GroupAgeGroup[] {
  return ageGroupIds.reduce((acc: GroupAgeGroup[], id) => {
    const ageGroup = ageGroups.find((ageGroup) => ageGroup.id === id);
    if (ageGroup) {
      acc.push({
        id: ageGroup.id,
        name: ageGroup.name,
        order: ageGroup.order,
        archived: ageGroup.archived ?? false,
      });
    }
    return acc;
  }, []);
}

export const getCriteriaCategory = (criteria: AvailableCriteria): PropertiesTextIds => {
  switch (criteria.type) {
    case FilterElementType.Subject:
      return 'subject';
    case FilterElementType.Group:
      return 'group';
    case FilterElementType.Gender:
      return 'gender';
    case FilterElementType.Nationality:
      return 'nationality';
    // biome-ignore lint/suspicious/useDefaultSwitchClauseLast: Legacy code
    default:
    case FilterElementType.Property: {
      return criteria.school_property?.type as PropertiesTextIds;
    }
  }
};
